import TreemapViz from '../vizs/TreemapViz'
import BaseComponent from './BaseComponent'

/**
 * {-EN-}
 * # {componentLabel} (`class {componentClassName}`)
 * Used to display hierarchical data that uses nested rectangles to represent the branches of a tree diagram.
 *
 *
 * ### Example Usage
 * ```javascript
 *   import {Treemap} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new Treemap($el, data, config);
 *
 * ```
 * ### Data structure {.section-data-structure}
 * The tabular data for this chart should be a table with 2 columns. First value represents the category and second represents its related value.
 *
 * | ID       |     value    |
 * | -------- | ------------ |
 * |   a      |    22.4      |
 * |   b      |    52.3      |
 * |   c      |    12.8      |
 * |   d      |    13.3      |
 *
 * {.data-table}
 * 
 * {-ES-}
 * # {componentLabelEs} (`class {componentClassName}`)
 * Se utiliza para mostrar datos jerárquicos que utilizan rectángulos anidados para representar las ramas de un diagrama de árbol.
 *
 *
 * ### Ejemplo de uso
 * ```javascript
 *   import {Treemap} from 'sdv-lib'
 *
 *   // Instantiate the chart with a DOM element, a data Array and a config Object
 *   let myChart = new Treemap($el, data, config);
 *
 * ```
 * ### Estructura de datos {.section-data-structure}
 * Los datos tabulares de este gráfico deben ser una tabla con 2 columnas. El primer valor representa la categoría y el segundo representa su valor relacionado.
 *
 * | ID       |     valor    |
 * | -------- | ------------ |
 * |   a      |    22.4      |
 * |   b      |    52.3      |
 * |   c      |    12.8      |
 * |   d      |    13.3      |
 *
 * {.data-table}
 *
 */
export default class TreemapComponent extends BaseComponent {
  static vizClass = TreemapViz
  static componentLabel = 'Treemap'
  static componentLabelEs = "Mapa de árbol"
  static dataFormat = [
    { index: 0, axis: '', types: [String], role: 'id', roleLabel: 'Category' },
    { index: 1, axis: '', types: [Number], role: 'value', roleLabel: 'Value' },
  ]
  static defaultConfig = {
    title: this.componentLabel,
    mode: 'rect',
    TooltipBehavior: {
      tooltipValueFormat: {
        exposed: true,
        nonEditable: false,
      },
    },
  }

  static dataRequirements = {
    recomendedMaxRows: 10,
    maxRows: 30,
    sign: 'positive', //'negative','any','both'
    avoidDates: true,
    requirementsStrength: 10,
  }
}
